import React from 'react';
import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { CalendarOutlined } from '@ant-design/icons';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Popover, Select } from 'antd';
import PropTypes from 'prop-types';

const { Option } = Select;

/**
 * Componente Molecule para seletor de competência
 */
function ApontamentoCompetenciaSelector({ competence, competences, disabled, parameterization, onCompetenceChange }) {
  let competenceLabel = <span>Competência</span>;
  if (parameterization?.exibe_param_apontamento && parameterization?.atual_comp_ap_qtd_dias) {
    competenceLabel = (
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        Competência
        <Popover
          title="Valores Parametrização"
          content={`Atualização da Competência no Apontamento no dia ${parameterization.atual_comp_ap_qtd_dias}`}
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            size="sm"
            style={{ marginLeft: '8px' }}
          />
        </Popover>
      </div>
    );
  }

  return (
    <Col
      xs={24}
      sm={24}
      md={12}
      lg={4}
      xl={4}
    >
      <Label label={competenceLabel}>
        <Select
          title="Competência"
          suffixIcon={<CalendarOutlined />}
          placeholder="MM/YYYY"
          defaultValue={competence}
          value={competence}
          disabled={disabled}
          onChange={onCompetenceChange}
        >
          {competences.map((item) => (
            <Option
              key={item.comp}
              value={item.comp}
            >
              {item.comp}
            </Option>
          ))}
        </Select>
      </Label>
    </Col>
  );
}

ApontamentoCompetenciaSelector.propTypes = {
  competence: PropTypes.string,
  competences: PropTypes.arrayOf(
    PropTypes.shape({
      comp: PropTypes.string,
    })
  ).isRequired,
  disabled: PropTypes.bool,
  parameterization: PropTypes.shape({
    exibe_param_apontamento: PropTypes.bool,
    atual_comp_ap_qtd_dias: PropTypes.number,
  }),
  onCompetenceChange: PropTypes.func.isRequired,
};

ApontamentoCompetenciaSelector.defaultProps = {
  competence: undefined,
  disabled: false,
  parameterization: undefined,
};

export default ApontamentoCompetenciaSelector;
